import en_US from "antd/lib/locale/en_US";
// import zh_HK from "antd/lib/locale/zh_HK";
// import ko_KR from "antd/lib/locale/ko_KR";
// import ja_JP from "antd/lib/locale/ja_JP";
// import hi_IN from "antd/lib/locale/hi_IN";
// import id_ID from "antd/lib/locale/id_ID";
// import ru_RU from "antd/lib/locale/ru_RU";
// import es_ES from "antd/lib/locale/es_ES";
// import tr_TR from "antd/lib/locale/tr_TR";
import vi_VN from "antd/lib/locale/vi_VN";
// import th_TH from "antd/lib/locale/th_TH";
// import fa_IR from "antd/lib/locale/fa_IR";
// import ku_IQ from "antd/lib/locale/ku_IQ";
import ar_EG from "antd/lib/locale/ar_EG";
import pt_BR from "antd/lib/locale/pt_BR";
import { createIntl, createIntlCache } from 'react-intl';

// 英语、葡语、阿拉伯语、越南语（antd 语言包）
const antdLocales = {
  en: en_US,
  ar: ar_EG,
  pt: pt_BR,
  vi: vi_VN,
};

/** 需要 RTL 镜像的语言（阿拉伯语等） */
export const RTL_LOCALES = ["ar"];

export function isRtlLocale(locale) {
  if (!locale) return false;
  const code = locale === "zh-CN" ? "cn" : locale === "zh-HK" ? "hk" : locale;
  return RTL_LOCALES.includes(code);
}

const localeMap = {
  en: { key: "en", code: "en", lab: "English" },
  ar: { key: "ar", code: "ar", lab: "العربية" },
  pt: { key: "pt", code: "pt", lab: "Português" },
  vi: { key: "vi", code: "vi", lab: "Tiếng Việt" },
  "zh-CN": { key: "zh-CN", code: "cn", lab: "简体中文" },
  "zh-HK": { key: "zh-HK", code: "hk", lab: "繁體中文" },
  default: { key: "en", code: "en", lab: "English" },
};

function resolveLangPack(langMessages, lang) {
  if (!langMessages) return null;
  if (lang === "default") return langMessages.en;
  return langMessages[lang] || null;
}

class XtLocale{
  constructor()
  {
    this.localeList = [];
    for (let key in localeMap) {
      if (key === "default") continue;
      const item = localeMap[key];
      if (!this.localeList.some((l) => l.code === item.code)) {
        this.localeList.push(item);
      }
    }
    this.messageMap = {};
  }
  init(currentLang, langs, langMessages)
  {
    var list = [];
    var map = {};
    for(let i=0;i<langs.length;++i)
    {
      let lang = langs[i];
      let item = localeMap[lang];
      if(item)
      {
        if (!list.some((l) => l.code === item.code)) {
          list.push(item);
        }
        map[lang] = {};
        function insertMessage(list, prefix){
          for(let key in list)
          {
            if(typeof(list[key]) == "string")
            {
              //i18n to intl
              const messageR = list[key].replace(/{{/g, "{").replace(/}}/g, "}");
              map[lang][prefix+key] = messageR;
            }
            else if(typeof(list[key]) == "object")
            {
              insertMessage(list[key], prefix+key+".");
            }
          }
        }
        const enPack = resolveLangPack(langMessages, "en");
        const langPack = resolveLangPack(langMessages, lang);
        if (enPack) insertMessage(enPack, "");
        if (langPack) insertMessage(langPack, "");
      }
    }
    this.localeList = list;
    this.messageMap = map;
    if (!this.messageMap[currentLang]) {
      currentLang = this.messageMap.en ? "en" : Object.keys(this.messageMap)[0] || "en";
    }
    const activeLocale = localeMap[currentLang] || localeMap.en;
    const cache = createIntlCache();
    this.intl = createIntl({
      locale: currentLang,
      messages: this.messageMap[currentLang],
    }, cache);
    this.intl.code = activeLocale.code;
    this.currentLang = currentLang;
  }
  addMessages(lang, messages){
    if(lang != this.intl.locale)
      return;
    for(let key in messages){
      this.messageMap[lang][key] = messages[key];
      this.intl.messages[key] = messages[key];
    }
  }
  hasKey(key){
    return key && this.messageMap[this.currentLang] && this.messageMap[this.currentLang][key];
  }
  getLocaleObj(lang){
    const { key,code } = this.localeList.find(
      (obj) => obj.key === lang || obj.code === lang
    ) || {
      key: "en",
      code: "en",
      lab: "English",
    };
    return {
      key,
      code,
      antd: antdLocales[code],
      message: this.messageMap[key],
    };
  }
  getLangPath(){
    if(typeof window == "undefined")
      return null;
    var path = location.pathname.split("/");
    if(path.length > 1 && localeMap[path[1]])
    {
      return path[1];
    }
    return null;
  }
  getLeftPath(){
    if(typeof window == "undefined")
      return null;
    var path = location.pathname.split("/");
    if(path.length > 1 && localeMap[path[1]])
    {
      path.shift();
      path.shift();
      if(path.length == 0)
        return location.search;
      return "/"+path.join("/")+location.search;
    }
    return location.pathname+location.search;
  }
  getLangCode(){
    var path = this.getLangPath();
    if(path)
    {
      var locale = localeMap[path];
      if(locale)
        return locale.code;
    }
    return null;
  }
  /** Zendesk Help Center 语言路径，与当前选择的语言一致，用于按语言传参 */
  getZenLan() {
    const zenLan = {
      "zh-CN": "zh-cn",
      "zh-HK": "zh-tw",
      en: "en-us",
      pt: "pt-br",
      ar: "ar",
      ja: "ja",
      ko: "ko-kr",
      ru: "ru",
      vi: "vi-vn",
    };
    return zenLan[this.intl.locale] || "en-us";
  }
}
export default new XtLocale();
